import type { Category } from "~/types"

export const useCategoryStore = defineStore('category', () => {
    const categories = ref<Category[]>([]);
    const pending = ref(false);
    const error = ref<Error | null>(null);
    const loaded = ref(false);

    const catalogService = useCatalogService();

    async function load() {
        pending.value = true;
        try {
            const response = await catalogService.getCategories();
            categories.value = response.data;
            loaded.value = true;
        } catch (err) {
            console.error("Error loading categories:", err);

            if (err instanceof Error) {
                error.value = err;
            } else {
                error.value = new Error(String(err));
            }
        } finally {
            pending.value = false;
        }
    }

    async function refresh() {

        const { $i18n } = useNuxtApp();
        console.log('Current locale in refresh:', $i18n.locale.value);
        // console.log(`Refreshing categories for locale: ${locale.value}`);
    }

    return {
        categories,
        load,
        pending,
        error,
        loaded,
        refresh
    }
})